var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnifiedProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "192px",
    height: "192px",
    viewBox: "0 0 192 192",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Other/logo/colored/Unified Profile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Other/logo/colored/Unified-Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "area",
    x: 0,
    y: 0,
    width: 192,
    height: 192
  }), /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(28.000000, 36.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87,110 L87,75.9886686 L107.325,75.9886686 C123.9875,75.9886686 136,64.2606232 136,46.7988669 C136,29.3371105 123.9875,18 107.325,18 L74,18 L74,110 L87,110 Z M105.385714,65 L87,65 L87,29 L105.514286,29 C116.314286,29 123,35.5934066 123,46.8021978 C123,58.010989 116.314286,65 105.385714,65 Z",
    id: "P",
    fill: "#222222",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#008ACE",
    points: "46.6987128 0.000238361444 37 0 0 120 9.44887326 120 19 120 56 0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnifiedProfile);
export default __webpack_public_path__ + "7f5e89a3bde633f70adaa69f98b967dd.svg";
export { ForwardRef as ReactComponent };